/**
 * Data layer for `igaming-bonus-cost-deduction-from-ngr-share`. Thin typed fetch wrappers over /api/v1/igaming-bonus-cost-deduction-from-ngr-share.
 * Raw `fetch()` is confined to this file per the dash contract.
 */

export interface IgamingBonusCostDeductionFromNgrShareRow {
	id: string;
	tenant_id: string;
	created_at: number;
	updated_at: number;
	[key: string]: unknown;
}

export interface ListIgamingBonusCostDeductionFromNgrShareResponse {
	count: number;
	items: IgamingBonusCostDeductionFromNgrShareRow[];
}

export interface CreateIgamingBonusCostDeductionFromNgrShareBody {
	[key: string]: unknown;
}

const BASE = "/api/v1/igaming-bonus-cost-deduction-from-ngr-share";

async function parseOrThrow<T>(res: Response): Promise<T> {
	const text = await res.text();
	let data: unknown = null;
	if (text) {
		try {
			data = JSON.parse(text);
		} catch {
			data = text;
		}
	}
	if (!res.ok) {
		const msg =
			data &&
			typeof data === "object" &&
			data !== null &&
			"error" in data &&
			typeof (data as { error: unknown }).error === "string"
				? (data as { error: string }).error
				: `HTTP ${res.status}`;
		throw new Error(msg);
	}
	return data as T;
}

export async function list(): Promise<ListIgamingBonusCostDeductionFromNgrShareResponse> {
	const res = await fetch(BASE, {
		method: "GET",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<ListIgamingBonusCostDeductionFromNgrShareResponse>(res);
}

export async function create(body: CreateIgamingBonusCostDeductionFromNgrShareBody): Promise<IgamingBonusCostDeductionFromNgrShareRow> {
	const res = await fetch(BASE, {
		method: "POST",
		credentials: "include",
		headers: {
			accept: "application/json",
			"content-type": "application/json",
		},
		body: JSON.stringify(body ?? {}),
	});
	return parseOrThrow<IgamingBonusCostDeductionFromNgrShareRow>(res);
}

export async function remove(id: string): Promise<{ removed: boolean }> {
	const res = await fetch(`${BASE}/${encodeURIComponent(id)}`, {
		method: "DELETE",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<{ removed: boolean }>(res);
}

export const igamingBonusCostDeductionFromNgrShareQueryKeys = {
	all: ["igaming-bonus-cost-deduction-from-ngr-share"] as const,
	list: () => [...igamingBonusCostDeductionFromNgrShareQueryKeys.all] as const,
	detail: (id: string) => [...igamingBonusCostDeductionFromNgrShareQueryKeys.all, id] as const,
};
